// client/src/components/backButton.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import './customButton.css';

const BackButton = ({ to, activeTab, label = '← Back', bgColor = '#667eea' }) => {
  const navigate = useNavigate();

  // const handleBack = () => {
  //   navigate(to, { state: { activeTab } });
  // };

  const handleBack = () => {
    const destination = isNaN(Number(to)) ? to : Number(to);
    navigate(destination, { state: { activeTab } });
  };

  return (
    <div className="shadow-button" style={{ borderColor: bgColor }}>
      <button
        className="custom-button"
        style={{ backgroundColor: bgColor }}
        onClick={handleBack}
      >
        {label}
      </button>
    </div>
  );
};

export default BackButton;
